import React, { useEffect, useState } from 'react';
import { auth, db } from '../FirebaseComp/firebase'; // Ensure correct path
import { doc, getDoc } from 'firebase/firestore';

import './userprofile.css';

function UserProfile() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      const currentUser = auth.currentUser;
      if (currentUser) {
        try {
          const userRef = doc(db, 'users', currentUser.uid);
          const docSnap = await getDoc(userRef);
          if (docSnap.exists()) {
            setUser(docSnap.data());
          } else {
            console.log("No such document!");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      }
    };
    fetchUserData();
  }, []);

  return (
    <>
            <section className="hero">
              <div className="hero-image">
                  <img src="/logo192.png" alt="conference" />
                </div>
                <div className="hero-content">
          <h1>Chavo Tours & Taxi</h1>
          <p>Welcome to Chavo Tours, your premier choice for taxi and tour services in Sri Lanka. 
            We offer reliable, safe, and affordable transportation for both tourists and locals. 
            Book your ride today for the best travel experience.</p>
                </div>
            </section>

    <div className="user-profile-container">
    <img src="/user.jpg" alt="User Profile" />
      <h2 className="user-profile-header">My Profile</h2>
      {user ? (
        <>
          <div className="user-info">
            <p className="user-info-item"><strong>Name:</strong> {user.name}</p>
            <p className="user-info-item"><strong>Email:</strong> {user.email}</p>
            <p className="user-info-item"><strong>Contact No:</strong> {user.contactNo}</p>
            <p className="user-info-item"><strong>Country:</strong> {user.country}</p>

          </div>
        </>
      ) : (
        <p>Hello,...</p>
      )}
    </div>
    </>
  );
}

export default UserProfile;
